[<AutoOpen>]
module Sm.UI.Components.Hooks

open Browser.Types

open Fable.Core
open Fable.React
open Fable.React.Props

let private prepareDeps = function
    | None -> JS.undefined<obj array>
    | Some deps -> deps

let inline captureRef (ref: IRefValue<_>) =
    Ref (fun x -> ref.current <- unbox x)

module private ScrollIntoViewHook =
    let useScrollIntoView dependencies test =
        let ref = Hooks.useRef<HTMLElement>(null)

        Hooks.useEffect(
            fun () -> (
                match ref.current with
                | HTMLElement e when test () ->
                    let options = JsInterop.createEmpty<ScrollIntoViewOptions>
                    options.behavior <- ScrollBehavior.Smooth
                    options.block <- ScrollAlignment.Nearest
                    e.scrollIntoView(options)
                | _ -> ()
            ),
            prepareDeps dependencies
        )
        ref

let useDependentScrollIntoView deps test =
    ScrollIntoViewHook.useScrollIntoView (Some deps) test
